import * as React from 'react';
import PropTypes from 'prop-types';
import ol_Map from 'ol/Map';
import ol_layer_Vector from 'ol/layer/Vector';
import ol_Feature from 'ol/Feature';
import ol_geom_Point from 'ol/geom/Point';
import ol_source_Vector from 'ol/source/Vector';
import {Util} from "../util";
import Map from '../map';

export class Vector extends React.Component {

  layer: ol_layer_Vector;

  options: any = {
    renderOrder: undefined,
    extent: undefined,
    minResolution: undefined,
    maxResolution: undefined,
    opacity: undefined,
    renderBuffer: undefined,
    source: undefined,
    style: undefined,
    updateWhileAnimating: undefined,
    updateWhileInteracting: undefined,
    visible: undefined
  };

  events: any = {
    'change': undefined,
    'change:extent': undefined,
    'change:maxResolution': undefined,
    'change:minResolution': undefined,
    'change:opacity': undefined,
    'change:preload': undefined,
    'change:source': undefined,
    'change:visible': undefined,
    'change:zIndex': undefined,
    'postcompose': undefined,
    'precompose': undefined,
    'propertychange': undefined,
    'render': undefined
  };

  constructor(props) {
    super(props);
  }

  render() {
    return null;
  }

  componentDidMount () {
    let options = Util.getOptions(Object.assign(this.options, this.props));
    this.layer = new ol_layer_Vector(options);
    if(this.props.zIndex){
      this.layer.setZIndex(this.props.zIndex);
    }  
    this.context.mapComp.layers.push(this.layer);

    let olEvents = Util.getEvents(this.events, this.props);
    for(let eventName in olEvents) {
      this.layer.on(eventName, olEvents[eventName]);
    }
    //hoan add dong nay de khi bat tat' layer moi hien thi
    if(this.context.mapComp.map) {
      this.context.mapComp.map.addLayer(this.layer);
    }
    console.log('vector layer did mount');
  }

  componentWillReceiveProps (nextProps) {
    if(nextProps !== this.props){
      let options = Util.getOptions(Object.assign(this.options, nextProps));
      this.context.mapComp.map.removeLayer(this.layer);
      this.layer = new ol_layer_Vector(options);
      if(this.props.zIndex){
        this.layer.setZIndex(this.props.zIndex);
      }
      this.context.mapComp.map.addLayer(this.layer);
      let olEvents = Util.getEvents(this.events, this.props);
      for(let eventName in olEvents) {
        this.layer.on(eventName, olEvents[eventName]);
      }
    }
  }
  
  componentWillUnmount () {
    this.context.mapComp.map.removeLayer(this.layer);
    console.log('vector layer un mounttttttttttttt');
  }

}

Vector['contextTypes'] = {
  mapComp: PropTypes.instanceOf(Map),
  map: PropTypes.instanceOf(ol_Map)
};
